var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[_c('b-badge',{attrs:{"variant":_vm.states[ _vm.item.status ].variant}},[_vm._v(_vm._s(_vm.states[ _vm.item.status ].label))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }